// @ts-nocheck
(function () {
    const SELECTORS = {
        block: "kaching-bundles-block",
        selectedBar: ".kaching-bundles__bar--selected",
        barPrice: ".kaching-bundles__bar-price",
        barCompare: ".kaching-bundles__bar-full-price",
        barTitle: ".kaching-bundles__bar-title",
        button: "button[data-kaching-atc-button]"
    };

    let refreshTimer = null;
    let kachingObserver = null;
    let observedKachingBlock = null;
    let lastGoodDisplay = "";
    let lastGoodPrice = null;
    let lastSelectedDealId = "";
    let currentActiveButton = null;
    let currentActiveForm = null;

    let atcLoadingDelayTimer = null;
    let atcQuietEndTimer = null;
    let atcFallbackTimer = null;
    let atcSessionActive = false;
    let atcInFlightRequests = 0;
    let skipNextTrackedCartRequest = false;
    let skipTrackedCartRequestTimer = null;

    function normalizeMoneyText(text) {
        return (text || "").trim().replace(/\s+/g, " ");
    }

    function moneyNumber(text) {
        const normalized = normalizeMoneyText(text);
        if (!normalized) return NaN;

        let num = normalized.replace(/[^\d.,-]/g, "");
        if (!num) return NaN;

        const hasComma = num.includes(",");
        const hasDot = num.includes(".");

        if (hasComma && hasDot) {
            const lastComma = num.lastIndexOf(",");
            const lastDot = num.lastIndexOf(".");

            if (lastComma > lastDot) {
                num = num.replace(/\./g, "").replace(",", ".");
            } else {
                num = num.replace(/,/g, "");
            }
        } else if (hasComma && !hasDot) {
            num = num.replace(",", ".");
        }

        return parseFloat(num);
    }

    function detectFormatSample(text) {
        const normalized = normalizeMoneyText(text);
        const symbol = normalized.match(/[^\d\s.,-]/)?.[0] || "€";
        const numeric = normalized.replace(/[^\d.,-]/g, "");

        let usesCommaDecimal = false;

        if (numeric.includes(",") && numeric.includes(".")) {
            usesCommaDecimal = numeric.lastIndexOf(",") > numeric.lastIndexOf(".");
        } else {
            usesCommaDecimal = numeric.includes(",") && !numeric.includes(".");
        }

        return {
            symbol,
            usesCommaDecimal
        };
    }

    function formatMoney(value, sampleText) {
        if (!Number.isFinite(value)) return "";

        const format = detectFormatSample(sampleText);
        const fixed = value.toFixed(2);

        return format.symbol + (format.usesCommaDecimal ? fixed.replace(".", ",") : fixed);
    }

    function getKachingBlock() {
        return document.querySelector(SELECTORS.block);
    }

    function getSelectedBar(kachingBlock) {
        if (!kachingBlock) return null;

        return (
            kachingBlock.querySelector(SELECTORS.selectedBar) ||
            document.querySelector(SELECTORS.selectedBar)
        );
    }

    function getDealBlock(kachingBlock) {
        if (!kachingBlock) return null;

        const raw = kachingBlock.getAttribute("deal-block");
        if (!raw) return null;

        try {
            return JSON.parse(raw);
        } catch (error) {
            return null;
        }
    }

    function getSelectedDealBarData(selectedBar, dealBlock) {
        if (!selectedBar || !dealBlock?.dealBars?.length) return null;

        const dealId = selectedBar.getAttribute("data-deal-bar-id");
        if (!dealId) return null;

        return (
            dealBlock.dealBars.find(function (bar) {
                return bar.id === dealId;
            }) || null
        );
    }

    function getQuantity(selectedBar, selectedDealBar) {
        if (selectedDealBar?.quantity) {
            const quantity = parseInt(selectedDealBar.quantity, 10);
            if (Number.isFinite(quantity) && quantity > 0) return quantity;
        }

        const titleText = normalizeMoneyText(
            selectedBar?.querySelector(SELECTORS.barTitle)?.textContent || ""
        );

        const titleQuantity = parseInt(titleText, 10);
        if (Number.isFinite(titleQuantity) && titleQuantity > 0) return titleQuantity;

        return 1;
    }

    function getButtonLabel(button) {
        return button.getAttribute("data-kaching-atc-label") || "In winkelwagen";
    }

    function getSelectedKachingPrices() {
        const kachingBlock = getKachingBlock();
        const selectedBar = getSelectedBar(kachingBlock);

        if (!kachingBlock || !selectedBar) return null;

        const dealId = selectedBar.getAttribute("data-deal-bar-id") || "";
        const dealBlock = getDealBlock(kachingBlock);
        const selectedDealBar = getSelectedDealBarData(selectedBar, dealBlock);

        const priceEl = selectedBar.querySelector(SELECTORS.barPrice);
        const storedTotalValue = moneyNumber(
            priceEl?.getAttribute("data-kaching-weight-total-value") || ""
        );
        const storedTotalText = normalizeMoneyText(
            priceEl?.getAttribute("data-kaching-weight-total-text") || ""
        );
        const hasStoredTotal = Number.isFinite(storedTotalValue) && !!storedTotalText;

        // Price-led replaces the visible Kaching price with two lines:
        // "per dag" followed by "totaal". Reading textContent at that point
        // would briefly treat the first (daily) number as the ATC price. The
        // experiment preserves the original total in data attributes before
        // changing the markup, so prefer that atomic source whenever present.
        const rawPriceText = hasStoredTotal
            ? storedTotalText
            : normalizeMoneyText(priceEl?.textContent || "");

        const rawCompareText = normalizeMoneyText(
            selectedBar.querySelector(SELECTORS.barCompare)?.textContent || ""
        );

        const rawPrice = hasStoredTotal ? storedTotalValue : moneyNumber(rawPriceText);
        const rawCompare = moneyNumber(rawCompareText);

        if (!Number.isFinite(rawPrice)) return null;

        const quantity = getQuantity(selectedBar, selectedDealBar);
        const isPricePerItem = dealBlock?.showPricesPerItem === true;

        let finalPrice = rawPrice;
        let finalCompare = rawCompare;

        if (isPricePerItem && quantity > 1) {
            // The preserved price is already the full bar total. An untouched
            // Kaching price and its compare-at value are still per item.
            if (!hasStoredTotal) {
                finalPrice = +(rawPrice * quantity).toFixed(2);
            }

            if (Number.isFinite(rawCompare)) {
                finalCompare = +(rawCompare * quantity).toFixed(2);
            }
        }

        const sampleText = rawPriceText || rawCompareText;

        return {
            dealId,
            priceText: formatMoney(finalPrice, sampleText),
            compareText: Number.isFinite(finalCompare)
                ? formatMoney(finalCompare, rawCompareText || sampleText)
                : "",
            finalPrice,
            finalCompare
        };
    }

    function buildDisplayText(button, prices) {
        const label = getButtonLabel(button);

        if (!prices?.priceText) {
            return lastGoodDisplay || label;
        }

        const showCompare =
            !!prices.compareText &&
            Number.isFinite(prices.finalCompare) &&
            Number.isFinite(prices.finalPrice) &&
            prices.finalCompare > prices.finalPrice;

        return showCompare
            ? `${label} | ${prices.compareText} ${prices.priceText}`
            : `${label} | ${prices.priceText}`;
    }

    function ensureVisualButtonContent(button) {
        let visual = button.querySelector("[data-kaching-atc-visual]");

        if (!visual) {
            visual = document.createElement("span");
            visual.className = "kaching-atc-visual";
            visual.setAttribute("data-kaching-atc-visual", "");

            visual.innerHTML =
                '<span class="kaching-atc-visual__label" data-kaching-atc-visual-label></span>' +
                '<span class="kaching-atc-visual__separator" data-kaching-atc-visual-separator></span>' +
                '<span class="kaching-atc-visual__compare" data-kaching-atc-visual-compare></span>' +
                '<span class="kaching-atc-visual__final" data-kaching-atc-visual-final></span>';

            const addedEl = button.querySelector(".add-to-cart__added");
            button.insertBefore(visual, addedEl || null);
        }

        return visual;
    }

    function renderDisplay(prices) {
        const buttons = document.querySelectorAll(SELECTORS.button);
        if (!buttons.length) return;

        buttons.forEach(function (button) {
            const label = getButtonLabel(button);
            const activePrices = prices || lastGoodPrice;

            const visual = ensureVisualButtonContent(button);
            if (!visual) return;

            const labelEl = visual.querySelector("[data-kaching-atc-visual-label]");
            const separatorEl = visual.querySelector("[data-kaching-atc-visual-separator]");
            const compareEl = visual.querySelector("[data-kaching-atc-visual-compare]");
            const finalEl = visual.querySelector("[data-kaching-atc-visual-final]");

            if (!labelEl || !separatorEl || !compareEl || !finalEl) return;

            const hasPrice = !!activePrices?.priceText;

            const showCompare =
                hasPrice &&
                !!activePrices.compareText &&
                Number.isFinite(activePrices.finalCompare) &&
                Number.isFinite(activePrices.finalPrice) &&
                activePrices.finalCompare > activePrices.finalPrice;

            labelEl.textContent = label;
            separatorEl.textContent = hasPrice ? " | " : "";
            compareEl.textContent = showCompare ? activePrices.compareText : "";
            finalEl.textContent = hasPrice ? activePrices.priceText : "";

            button.setAttribute("data-kaching-atc-ready", "true");
            button.setAttribute("data-kaching-atc-display", buildDisplayText(button, activePrices));

            if (
                atcSessionActive &&
                (
                    button === currentActiveButton ||
                    (currentActiveForm && currentActiveForm.contains(button))
                )
            ) {
                showCustomATCLoaderNow(button);
            }

            lastGoodDisplay = buildDisplayText(button, activePrices);
        });
    }

    function updateDisplay() {
        const prices = getSelectedKachingPrices();

        if (prices?.priceText) {
            lastGoodPrice = prices;
            lastSelectedDealId = prices.dealId || lastSelectedDealId;
            renderDisplay(prices);
            return;
        }

        renderDisplay(lastGoodPrice);
    }

    function scheduleUpdate() {
        clearTimeout(refreshTimer);

        requestAnimationFrame(function () {
            bindButtons();
            updateDisplay();
        });

        refreshTimer = setTimeout(function () {
            bindButtons();
            updateDisplay();
        }, 900);
    }

    function scheduleSettledUpdate() {
        scheduleUpdate();

        setTimeout(scheduleUpdate, 80);
        setTimeout(scheduleUpdate, 220);
        setTimeout(scheduleUpdate, 500);
    }

    function getActiveATCButton() {
        if (currentActiveButton?.isConnected) return currentActiveButton;

        const formButton = currentActiveForm?.querySelector?.(SELECTORS.button);
        if (formButton) {
            currentActiveButton = formButton;
            return formButton;
        }

        return document.querySelector(SELECTORS.button);
    }

    function isCartUrl(url) {
        if (!url) return false;

        try {
            const parsed = new URL(url, window.location.origin);
            const path = parsed.pathname;

            if (/\/cart\/add(\.js)?$/i.test(path)) return true;

            if (
                atcSessionActive &&
                (
                    /\/cart\/change(\.js)?$/i.test(path) ||
                    /\/cart\/update(\.js)?$/i.test(path) ||
                    /\/cart(\.js)?$/i.test(path) ||
                    parsed.search.includes("sections=") ||
                    url.includes("cart-drawer") ||
                    url.includes("cart-notification")
                )
            ) {
                return true;
            }
        } catch (error) {
            return /\/cart\/add|\/cart\/change|\/cart\/update|cart-drawer|cart-notification/i.test(url);
        }

        return false;
    }

    function getCurrentProductForm() {
        return document.querySelector("product-form-component[data-product-id]") || null;
    }

    function getCurrentProductVariantId() {
        return getCurrentProductForm()?.querySelector('input[name="id"]')?.value || "";
    }

    function getCurrentProductVariantIds() {
        const form = getCurrentProductForm();
        const raw = form?.dataset?.variantPrices || "";

        if (!raw) return [];

        try {
            return Object.keys(JSON.parse(raw));
        } catch (error) {
            return [];
        }
    }

    function variantBelongsToCurrentProduct(variantId) {
        const id = String(variantId || "");
        if (!id) return true;

        const variantIds = getCurrentProductVariantIds();
        if (!variantIds.length) return true;

        return variantIds.includes(id);
    }

    function normalizeCartAddBody(resource, init) {
        let url = "";

        if (typeof resource === "string") {
            url = resource;
        } else if (resource && resource.url) {
            url = resource.url;
        }

        if (!/\/cart\/add(\.js)?$/i.test(url || "")) return init;

        const currentVariantId = getCurrentProductVariantId();
        if (!currentVariantId) return init;

        const nextInit = init ? { ...init } : {};
        const body = nextInit.body;

        if (body instanceof FormData) {
            const submittedId = body.get("id");

            if (submittedId && !variantBelongsToCurrentProduct(submittedId)) {
                body.set("id", currentVariantId);
            }

            return nextInit;
        }

        if (body instanceof URLSearchParams) {
            const submittedId = body.get("id");

            if (submittedId && !variantBelongsToCurrentProduct(submittedId)) {
                body.set("id", currentVariantId);
            }

            return nextInit;
        }

        if (typeof body === "string" && body.trim().startsWith("{")) {
            try {
                const json = JSON.parse(body);

                if (json?.id && !variantBelongsToCurrentProduct(json.id)) {
                    json.id = Number(currentVariantId);
                    nextInit.body = JSON.stringify(json);
                }
            } catch (error) {}
        }

        return nextInit;
    }

    function showCustomATCLoaderNow(button) {
        if (!button) return;

        button.setAttribute("data-kaching-atc-loading", "true");
    }

    function startATCLoadingSession(button) {
        if (!button) return;

        currentActiveButton = button;
        currentActiveForm = button.closest("form");
        atcSessionActive = true;

        clearTimeout(atcLoadingDelayTimer);
        clearTimeout(atcQuietEndTimer);
        clearTimeout(atcFallbackTimer);

        showCustomATCLoaderNow(button);

        atcFallbackTimer = setTimeout(function () {
            endATCLoadingSession();
        }, 10000);
    }

    function scheduleEndATCLoadingSession() {
        clearTimeout(atcQuietEndTimer);

        atcQuietEndTimer = setTimeout(function () {
            if (atcInFlightRequests <= 0) {
                endATCLoadingSession();
            }
        }, 180);
    }

    function endATCLoadingSession() {
        const button = getActiveATCButton();

        clearTimeout(atcLoadingDelayTimer);
        clearTimeout(atcQuietEndTimer);
        clearTimeout(atcFallbackTimer);

        atcSessionActive = false;
        atcInFlightRequests = 0;

        document.querySelectorAll(SELECTORS.button).forEach(function (item) {
            item.removeAttribute("data-kaching-atc-loading");
        });

        renderDisplay(lastGoodPrice);

        currentActiveButton = null;
        currentActiveForm = null;
    }

    function markSubmitting(button) {
        if (!button || button.disabled) return;

        startATCLoadingSession(button);
    }

    function beginTrackedCartRequest() {
        if (skipNextTrackedCartRequest) {
            skipNextTrackedCartRequest = false;
            clearTimeout(skipTrackedCartRequestTimer);
            return;
        }

        if (!atcSessionActive && !currentActiveButton) return;

        const button = currentActiveButton;
        if (button) {
            startATCLoadingSession(button);
        }

        atcInFlightRequests += 1;
    }

    function finishTrackedCartRequest() {
        atcInFlightRequests = Math.max(0, atcInFlightRequests - 1);
        scheduleEndATCLoadingSession();
    }

    function bindCartAddFetchWatcher() {
        if (window.__kachingAtcFetchWatcherBound) return;
        window.__kachingAtcFetchWatcherBound = true;

        const originalFetch = window.fetch;

        window.fetch = function () {
            const args = Array.prototype.slice.call(arguments);
            const resource = args[0];

            let url = "";

            if (typeof resource === "string") {
                url = resource;
            } else if (resource && resource.url) {
                url = resource.url;
            }

            const shouldTrack = isCartUrl(url);

            if (!shouldTrack) {
                return originalFetch.apply(this, args);
            }

            if (args.length > 1) {
                args[1] = normalizeCartAddBody(args[0], args[1]);
            }

            beginTrackedCartRequest();

            return originalFetch.apply(this, args).finally(function () {
                finishTrackedCartRequest();
            });
        };

        const originalOpen = XMLHttpRequest.prototype.open;
        const originalSend = XMLHttpRequest.prototype.send;

        XMLHttpRequest.prototype.open = function (method, url) {
            this.__kachingAtcUrl = url;
            return originalOpen.apply(this, arguments);
        };

        XMLHttpRequest.prototype.send = function () {
            const xhr = this;
            const shouldTrack = isCartUrl(xhr.__kachingAtcUrl || "");

            if (shouldTrack) {
                beginTrackedCartRequest();

                xhr.addEventListener("loadend", function () {
                    finishTrackedCartRequest();
                });
            }

            return originalSend.apply(this, arguments);
        };
    }

    function bindButtons() {
        function skipUpcomingTrackedCartRequest() {
            skipNextTrackedCartRequest = true;
            clearTimeout(skipTrackedCartRequestTimer);
            skipTrackedCartRequestTimer = setTimeout(function () {
                skipNextTrackedCartRequest = false;
            }, 1500);
        }

        if (!window.__kachingAtcUpsellGuardBound) {
            window.__kachingAtcUpsellGuardBound = true;

            document.addEventListener(
                "click",
                function (event) {
                    if (event.target?.closest?.(".new-upsell-custom-products button[name='add']")) {
                        skipUpcomingTrackedCartRequest();
                    }
                },
                true
            );

            document.addEventListener(
                "submit",
                function (event) {
                    if (event.target?.closest?.(".new-upsell-custom-products")) {
                        skipUpcomingTrackedCartRequest();
                    }
                },
                true
            );
        }

        document.querySelectorAll(SELECTORS.button).forEach(function (button) {
            if (button.__kachingAtcDisplayBound) return;
            button.__kachingAtcDisplayBound = true;

            button.addEventListener(
                "click",
                function () {
                    markSubmitting(button);
                },
                true
            );

            const form = button.closest("form");
            if (form && !form.__kachingAtcSubmitBound) {
                form.__kachingAtcSubmitBound = true;

                form.addEventListener(
                    "submit",
                    function () {
                        markSubmitting(button);
                    },
                    true
                );
            }
        });
    }

    function bindATCEndEvents() {
        if (window.__kachingAtcEndEventsBound) return;
        window.__kachingAtcEndEventsBound = true;

        document.addEventListener("cart:update", function (event) {
            if (event.detail?.data?.source !== "product-form-component") return;

            setTimeout(endATCLoadingSession, 120);
        });

        document.addEventListener("cart:error", function () {
            endATCLoadingSession();
        });

        document.addEventListener("dialog:open", function (event) {
            if (!event.target?.closest?.("cart-drawer-component")) return;

            setTimeout(endATCLoadingSession, 120);
        });
    }

    function bindKachingEvents() {
        const kachingBlock = getKachingBlock();
        if (!kachingBlock) return;

        if (observedKachingBlock && observedKachingBlock !== kachingBlock && kachingObserver) {
            kachingObserver.disconnect();
            kachingObserver = null;
            observedKachingBlock = null;
        }

        if (!kachingBlock.__kachingAtcDisplayBound) {
            kachingBlock.__kachingAtcDisplayBound = true;

            kachingBlock.addEventListener("deal-bar-selected", scheduleUpdate);

            kachingBlock.addEventListener(
                "change",
                function (event) {
                    const target = event.target;
                    if (!target || !target.closest) return;

                    if (target.closest(".kaching-bundles__bar select")) {
                        scheduleSettledUpdate();
                    }
                },
                true
            );
        }

        if (!kachingObserver) {
            kachingObserver = new MutationObserver(function (mutations) {
                let shouldUpdate = false;

                mutations.forEach(function (mutation) {
                    if (mutation.type === "attributes" && mutation.attributeName === "deal-block") {
                        shouldUpdate = true;
                    }

                    if (
                        mutation.type === "attributes" &&
                        mutation.attributeName === "class" &&
                        mutation.target?.classList?.contains("kaching-bundles__bar")
                    ) {
                        shouldUpdate = true;
                    }

                    if (mutation.type === "childList" || mutation.type === "characterData") {
                        shouldUpdate = true;
                    }
                });

                if (shouldUpdate) {
                    scheduleSettledUpdate();
                }
            });

            kachingObserver.observe(kachingBlock, {
                subtree: true,
                childList: true,
                characterData: true,
                attributes: true,
                attributeFilter: ["class", "deal-block"]
            });

            observedKachingBlock = kachingBlock;
        }
    }

    function init() {
        if (!document.querySelector(SELECTORS.button)) return;

        if (!atcSessionActive) {
            document.querySelectorAll(SELECTORS.button).forEach(function (button) {
                button.removeAttribute("data-kaching-atc-loading");
            });
        }

        bindCartAddFetchWatcher();
        bindATCEndEvents();
        bindButtons();
        bindKachingEvents();
        scheduleUpdate();

        let attempts = 0;

        const interval = setInterval(function () {
            attempts += 1;

            bindButtons();
            bindKachingEvents();

            if (getKachingBlock()?.querySelector(SELECTORS.selectedBar) || attempts >= 20) {
                scheduleUpdate();
                clearInterval(interval);
            }
        }, 200);
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", init);
    } else {
        init();
    }

    document.addEventListener("kaching-bundles-initialized", init);
    document.addEventListener("shopify:section:load", init);
    document.addEventListener("ps:navigation:complete", function () {
        lastGoodDisplay = "";
        lastGoodPrice = null;
        lastSelectedDealId = "";
        currentActiveButton = null;
        currentActiveForm = null;
        scheduleSettledUpdate();
    });
    document.addEventListener("variant:update", scheduleSettledUpdate);
})();

(function () {
    if (window.__DOGSUPPY_PRODUCT_SELECTOR_NAV__) return;
    window.__DOGSUPPY_PRODUCT_SELECTOR_NAV__ = true;

    const LINK_SELECTOR = ".product-selector-normal, .product-selector-grote";
    const LOADER_ID = "ps-loading-overlay";
    const STYLE_ID = "ps-loading-style";

    let isNavigating = false;

    function ensureLoaderStyles() {
        if (document.getElementById(STYLE_ID)) return;

        const style = document.createElement("style");
        style.id = STYLE_ID;
        style.textContent = `
            #${LOADER_ID} {
                position: fixed;
                inset: 0;
                z-index: 99999;
                display: flex;
                align-items: center;
                justify-content: center;
                background: rgba(0, 0, 0, 0.28);
                backdrop-filter: saturate(120%) blur(3px);
                -webkit-backdrop-filter: saturate(120%) blur(3px);
                opacity: 0;
                transition: opacity 180ms ease;
            }

            #${LOADER_ID}.is-visible {
                opacity: 1;
            }

            #${LOADER_ID} .ps-loading-spinner {
                width: 40px;
                height: 40px;
                border-radius: 9999px;
                border: 4px solid rgba(255, 255, 255, 0.35);
                border-top-color: #fff;
                animation: ps-loading-spin 800ms linear infinite;
            }

            body.ps-loading {
                cursor: progress;
                user-select: none;
            }

            body.ps-loading ${LINK_SELECTOR} {
                pointer-events: none;
            }

            @keyframes ps-loading-spin {
                to { transform: rotate(360deg); }
            }
        `;

        document.head.appendChild(style);
    }

    function showLoader() {
        ensureLoaderStyles();

        let overlay = document.getElementById(LOADER_ID);

        if (!overlay) {
            overlay = document.createElement("div");
            overlay.id = LOADER_ID;
            overlay.setAttribute("aria-hidden", "true");
            overlay.innerHTML = '<div class="ps-loading-spinner"></div>';
            document.body.appendChild(overlay);
        }

        document.body.classList.add("ps-loading");

        requestAnimationFrame(function () {
            overlay.classList.add("is-visible");
        });
    }

    function hideLoader() {
        const overlay = document.getElementById(LOADER_ID);
        document.body.classList.remove("ps-loading");

        if (!overlay) return;

        overlay.classList.remove("is-visible");

        setTimeout(function () {
            overlay.remove();
        }, 200);
    }

    function navigateTo(url) {
        if (isNavigating || !url) return;

        isNavigating = true;
        showLoader();

        window.location.href = url;
    }

    function bindSelectorLinks() {
        document.querySelectorAll(LINK_SELECTOR).forEach(function (link) {
            if (link.__productSelectorNavBound) return;

            link.__productSelectorNavBound = true;

            link.addEventListener("click", function (event) {
                const href = link.getAttribute("href");
                if (!href) return;

                let targetUrl;

                try {
                    targetUrl = new URL(href, location.href);
                } catch (error) {
                    return;
                }

                if (targetUrl.pathname === location.pathname) return;

                event.preventDefault();
                navigateTo(targetUrl.toString());
            });
        });
    }

    window.addEventListener("pageshow", function (event) {
        if (!event.persisted) return;

        isNavigating = false;
        hideLoader();
    });

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", bindSelectorLinks);
    } else {
        bindSelectorLinks();
    }

    document.addEventListener("shopify:section:load", bindSelectorLinks);
})();
